module.exports = __webpack_public_path__ + "static/media/Material Tile Roof 1.fa0763b1.svg";